export const gpsMessage =   `<p>Tu auto ha sido seleccionado para el servicio de Ituran Protección con seguimiento en tiempo real.</p>
                            <p>Comunícate al <a href="tel:+528009119898">800 911 9898</a> para completar tu registro. <br><br> Ahora tendrá
                            en tus manos la mejor tecnología israelí de monitoreo con GPS</p>`


export const errorMsgPedido =   `<h4>NO PODEMOS CONTINUAR CON EL REGISTRO DE TUS DATOS</h4>
<p>Contactanos al <a href="tel:+528009119898">800 911 9898</a> para continuar con tu registro.</p>`


export const errorMsgPago = `<h4>Hubo un error al procesar los métodos de pago.</h4>
<p>Contactanos al <a href="tel:+528009119898">800 911 9898</a> para continuar con tu registro.</p>`

export const msgPagando = `<h4>Una vez realizado tu pago presiona el botón Continuar.</h4>
<p>Si no puedes ver el enlace desactiva cualquier bloqueador de ventanas emergentes de tu navegador y abre el enlace de nuevo.</p>`